/**
 * The JUDGED scoring rules — the names only, apart from `judged.ts` so the
 * family schema (`results.ts`, `config.scoring.rule`) can list them without
 * importing the scoring code (which imports `results.ts`'s types back).
 *
 * One rule per way of turning a panel's marks into a score. Which rule a meet
 * uses is decided from the CODES (sport, discipline, event, the meet's slot
 * count and phase type) by `judgedRuleOf` in `judged.ts`, never from a name;
 * a meet may name another one in `config.scoring.rule` (a TD's call, e.g.
 * kata by points in a medal bout).
 *
 *   KATA_POINTS        karate kata ranking round: 7 judges × technical + athletic, 2 + 2 dropped
 *   KATA_FLAGS         karate kata bout (the old OVR): each judge's mark per side, the higher one gets the judge's vote
 *   SILAT_SENI         pencak silat seni (the old OVR): 6 judges, middle marks averaged, minus the foul; lower SD breaks a tie
 *   TAOLU              wushu taolu (the old OVR): panel results A + B + C + bonus − deduction
 *   TAOLU_COMBINED     wushu two-routine event (the old OVR): routine 1 + routine 2
 *   POOMSAE            taekwondo recognised poomsae: accuracy + presentation, high / low dropped, poomsae averaged
 *   POOMSAE_FREESTYLE  taekwondo freestyle poomsae: technical skills + presentation
 *   DANCE_SKATING      dancesport final: each judge places the couples, the Skating System decides (lower wins)
 *   DANCE_RECALLS      dancesport preliminary round: each judge's cross (recall), most crosses go through
 *   BREAKING_BATTLE    breaking battle: each judge votes per round, the most rounds win
 *   JUDO_KATA          judo kata: 5 judges' totals, high and low dropped
 *   WAI_KRU            muay wai kru: judges' marks averaged, high and low dropped with 5
 *   DRESSAGE           equestrian dressage: each judge's percentage, averaged
 *   DRESSAGE_TEAM      team dressage: the riders' percentages, the best ones counted
 *   FIGURE_SKATING     figure skating: per segment TES + PCS × factor − deductions; short + free
 *   WAKEBOARD          wakeboard: the judges' totals averaged, high and low dropped with 5
 *   MANUAL             no formula: the operator types the total (gymnastics until the new TSR, diving, …)
 */
export const JUDGED_RULES = [
	"KATA_POINTS",
	"KATA_FLAGS",
	"SILAT_SENI",
	"TAOLU",
	"TAOLU_COMBINED",
	"POOMSAE",
	"POOMSAE_FREESTYLE",
	"DANCE_SKATING",
	"DANCE_RECALLS",
	"BREAKING_BATTLE",
	"JUDO_KATA",
	"WAI_KRU",
	"DRESSAGE",
	"DRESSAGE_TEAM",
	"FIGURE_SKATING",
	"WAKEBOARD",
	"MANUAL",
] as const;
export type JudgedRule = (typeof JUDGED_RULES)[number];

/** The most judges a panel group seats (a seat code is ≤ 8 characters: "AC15"). */
export const JUDGED_PANEL_MAX = 15;
/** The most parts (dances, rounds, riders, segments) one result holds. */
export const JUDGED_PARTS_MAX = 12;
